import { render, staticRenderFns } from "./DenominatorSelectEditor.vue?vue&type=template&id=4b8f36f3&scoped=true&"
import script from "./DenominatorSelectEditor.vue?vue&type=script&lang=js&"
export * from "./DenominatorSelectEditor.vue?vue&type=script&lang=js&"
import style0 from "./DenominatorSelectEditor.vue?vue&type=style&index=0&id=4b8f36f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f36f3",
  null
  
)

export default component.exports